import React from 'react';

function Product(props) {
    return (
        <div className="congrat-row">
            <div className="title">
                <h1>Congrats you should try</h1>
            </div>
            <h3>{props.product.productName} </h3>
            <div className="img">
                <img src={props.product.productImageUrl} alt={props.product.productName} />
            </div>
            <div className="link"><a href={props.product.productLink} target= "_blank" rel="noopener noreferrer">{props.product.productLinkText}</a></div>
            <button type="button" className="med-secondary-button" onClick={props.resetSurvey}>Start Over</button>
        </div>

    )
}

export default Product
